import { render, staticRenderFns } from "./Stylists.vue?vue&type=template&id=a215dc0c"
import script from "./Stylists.vue?vue&type=script&lang=js"
export * from "./Stylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports